<template>
	<div>
		<article class="iv2-article" v-if="pageActive">
			<HomeScroll />
			<LayoutHero :items="items" />
			<LayoutPattern :items="items" />
			<LayoutNews />
			<LayoutRSS />
		</article>
		<div v-if="loading">
			<BaseLoading />
		</div>
	</div>
</template>

<script>
import HomeScroll from "./components/HomeScroll.vue";
import LayoutHero from "./components/LayoutHero.vue";
import LayoutPattern from "./components/LayoutPattern.vue";
import LayoutNews from "./components/LayoutNews.vue";
import LayoutRSS from "./components/LayoutRSS.vue";
import BaseLoading from "@/components/item/BaseLoading.vue";

import Meta from "@/mixins/MetaSettable";
import Hash from "@/mixins/AnchorLink";

export default {
	mixins: [Meta, Hash],

	props: ["animation"],

	components: {
		HomeScroll,
		LayoutHero,
		LayoutPattern,
		LayoutNews,
		LayoutRSS,
		BaseLoading,
	},

	data() {
		return {
			items: [],
			pageActive: false,
			loading: true,
		};
	},

	created() {
		this.axios.get("/json/home.json").then((response) => {
			this.items = response.data.page;
			this.loading = false;
			this.pageActive = true;
		});
	},
};
</script>

<style lang="scss"></style>
